import { NavLink } from "react-router-dom";
import { navigation } from "@/data/navigation";
import { externalLinkProps } from "@/lib/externalLink";
import { tField } from "@/lib/i18nField";
import { resolveRoute } from "@/lib/resolveRoute";

export default function MainNav({ lang }) {
  return (
    <nav className="tgwe-nav" aria-label="Primary navigation">
      {navigation.map((item) => {
        const label = tField(item.label, lang);
        if (item.type === "external-boundary") {
          return (
            <a key={item.key} className="tgwe-nav__link tgwe-nav__link--boundary" href={item.href} {...externalLinkProps(item.href)}>
              {label}
            </a>
          );
        }
        return (
          <NavLink key={item.key} className="tgwe-nav__link" to={resolveRoute(lang, item.key)}>
            {label}
          </NavLink>
        );
      })}
    </nav>
  );
}
